import { render, staticRenderFns } from "./CommitteeAppraisalDocuments.vue?vue&type=template&id=61fdb432&scoped=true"
import script from "./CommitteeAppraisalDocuments.vue?vue&type=script&lang=js"
export * from "./CommitteeAppraisalDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fdb432",
  null
  
)

export default component.exports